export default __webpack_public_path__ + "static/media/Background 5_00019.95cc3074.png";